function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { addYears } from 'date-fns';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { useAsyncFn } from 'react-use';
import Button from '../../components/button/Button';
import List from '../../components/list/List';
import Loading from '../../components/loading/Loading';
import { CANCEL_MEMBERSHIP_MODAL } from '../../components/modal/CancelMembershipModal';
import { BILLING_CYCLE, MEMBERSHIP } from '../../constants/membership';
import { showModal } from '../../redux/actions/index';
import routes from '../../routes/constants';
import text from '../../text';
import { client } from '../../utilities/api';
import { formatDate } from '../../utilities/date';
import { getTrialResidualDays, isTrialMembership } from '../../utilities/membership';
import { getUserMembership, isUserGovernment, isUserUnderTrial } from '../../utilities/user';
var _obj;
var MEMBERSHIP_TEXT = (_obj = {}, _define_property(_obj, MEMBERSHIP.MONTHLY.PRICE_ID, {
    CONTRACT_MESSAGE: text('monthlyContractMessage')
}), _define_property(_obj, MEMBERSHIP.YEARLY.PRICE_ID, {
    CONTRACT_MESSAGE: text('annualContractMessage')
}), _obj);
var getBillingCycleDisplayName = function(membership) {
    return (membership === null || membership === void 0 ? void 0 : membership.billing_cycle) && text(BILLING_CYCLE[membership === null || membership === void 0 ? void 0 : membership.billing_cycle]);
};
var Membership = function(props) {
    var _MEMBERSHIP_TEXT_membership_price_id, _membershipDetailsState_value, _membershipDetailsState_value1;
    var membership = props.membership, currentUser = props.currentUser, onCancelMembership = props.onCancelMembership;
    var history = useHistory();
    var _useAsyncFn = _sliced_to_array(useAsyncFn(/*#__PURE__*/ _async_to_generator(function() {
        var data;
        return _ts_generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        client.getUserMembership()
                    ];
                case 1:
                    data = _state.sent().data;
                    return [
                        2,
                        data
                    ];
            }
        });
    })), 2), membershipDetailsState = _useAsyncFn[0], getMembershipDetails = _useAsyncFn[1];
    useEffect(function() {
        if (currentUser) {
            getMembershipDetails();
        }
    }, []);
    return /*#__PURE__*/ React.createElement("div", {
        className: "Membership"
    }, !membershipDetailsState.loading ? /*#__PURE__*/ React.createElement(React.Fragment, null, membership ? /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("h4", {
        className: "mb-2"
    }, isUserUnderTrial(currentUser) ? "".concat(text('trial'), "*") : membership.name), /*#__PURE__*/ React.createElement("div", {
        className: "mb-4"
    }, /*#__PURE__*/ React.createElement("p", {
        className: "mb-1"
    }, isUserUnderTrial(currentUser) ? text('trialMembershipSummary') : (_MEMBERSHIP_TEXT_membership_price_id = MEMBERSHIP_TEXT[membership.price_id]) === null || _MEMBERSHIP_TEXT_membership_price_id === void 0 ? void 0 : _MEMBERSHIP_TEXT_membership_price_id.CONTRACT_MESSAGE), isUserUnderTrial(currentUser) && /*#__PURE__*/ React.createElement("p", {
        className: "m-0"
    }, text('receiveEmailBeforeTrialExpires'))), /*#__PURE__*/ React.createElement(List, {
        isBorderless: true,
        isPaddingless: true
    }, /*#__PURE__*/ React.createElement("tbody", null, isTrialMembership(membership) && getTrialResidualDays(membership) >= 0 && /*#__PURE__*/ React.createElement(List.Item, {
        className: "pb-2",
        isColonAppended: true,
        isValueSecondaryHighlight: true,
        value: text('numberOfDays', {
            daysNumber: getTrialResidualDays(membership)
        }),
        description: text('trialExpiresIn')
    }), /*#__PURE__*/ React.createElement(List.Item, {
        className: "pb-2",
        isColonAppended: true,
        value: getBillingCycleDisplayName(membership),
        description: text('billingCycle')
    }), ((_membershipDetailsState_value = membershipDetailsState.value) === null || _membershipDetailsState_value === void 0 ? void 0 : _membershipDetailsState_value.next_invoice.payment_attempt) ? /*#__PURE__*/ React.createElement(List.Item, {
        className: "pb-2",
        isColonAppended: true,
        value: formatDate((_membershipDetailsState_value1 = membershipDetailsState.value) === null || _membershipDetailsState_value1 === void 0 ? void 0 : _membershipDetailsState_value1.next_invoice.payment_attempt),
        description: text('nextChargeDate')
    }) : null, /*#__PURE__*/ React.createElement(List.Item, {
        className: "pb-2",
        isColonAppended: true,
        value: formatDate(membership.start_date && addYears(new Date(membership.start_date), 1)),
        description: text('contractRenewalDate')
    })))) : null, /*#__PURE__*/ React.createElement("p", null, text('findOutMoreOnPage', {
        page: /*#__PURE__*/ React.createElement("a", {
            rel: "noreferrer",
            target: "_blank",
            href: routes.larkiWebsiteUrl.memberships
        }, text('membershipPage'))
    })), !isUserGovernment(currentUser) && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement(Button, {
        className: "mb-3",
        onClick: function() {
            return history.push({
                pathname: routes.user.membershipManagement,
                state: {
                    redirectTo: {
                        path: "".concat(routes.user.profile, "?focusedTab=membership"),
                        label: text('navigateToRoute', {
                            navigation: 'Back',
                            routeName: text('account')
                        })
                    }
                }
            });
        }
    }, text('change')), /*#__PURE__*/ React.createElement(Button, {
        variant: "link",
        className: "p-0 secondary",
        onClick: function() {
            return onCancelMembership();
        }
    }, text('cancelMembership')))) : /*#__PURE__*/ React.createElement(Loading, null));
};
var MembershipWithState = function() {
    var userProfile = useSelector(function(state) {
        return state.profileReducer;
    }).userProfile;
    var dispatch = useDispatch();
    return /*#__PURE__*/ React.createElement(Membership, {
        onCancelMembership: function(props) {
            dispatch(showModal(CANCEL_MEMBERSHIP_MODAL, props));
        },
        membership: getUserMembership(userProfile),
        currentUser: userProfile
    });
};
export default MembershipWithState;
